import { availabilityConstants } from "../constants";

const initialState =  { loading: null, lists: null, } || {};

export function availabilitys(state = initialState, action) {
    switch (action.type) {
    case availabilityConstants.GETALLAVAILBILITYS_REQUEST:
        return {
            loading: true
        };
    case availabilityConstants.GETALLAVAILBILITYS_SUCCESS:
        return {
            loading: false,
            lists: action.lists.data
        };
    case availabilityConstants.GETALLAVAILBILITYS_FAILURE:
        return { 
            error: action.error
        };
   
    default:
        return state;
    }
}

